import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Select from "react-select";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import "./PinnedContentTableStyles.css";
import PatientLoader from "../../../../common/PatientLoader";
import { notify, normalizeMediaType, CMS_SLUG_TO_LABEL } from "../../../../../util/helpers";
import axiosInstance, { CMS_BASE_URL } from "../../../../../axios";
import {
  fetchPatientPCLogic,
  pinContentForPatientLogic,
} from "../../../../../store/features/patient/pinnedContentSlice";
import { useDispatch } from "react-redux";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "60%",
  },
};

const PinNewContent = ({ modalIsOpen, setModalOpen, patientID }) => {
  Modal.setAppElement("#root");
  //TODO: Memoize this and PinnedContent Pages

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedContent, setSelectedContent] = useState(null);
  const [categories, setCategories] = useState([]);
  const [media, setMedia] = useState([
    {
      label: "Videos",
      value: "Videos",
    },
    {
      label: "Audio",
      value: "Audio",
    },
    {
      label: "Article",
      value: "Article",
    },
    // {
    //   label: "TikToks",
    //   value: "TikToks",
    // },
  ]);
  const [content, setContent] = useState([]);

  const [formattedData, setFormattedData] = useState([]);
  const [data, setData] = useState([]);

  const closeModal = () => {
    setSelectedCategory(null);
    setSelectedMedia(null);
    setSelectedContent(null);
    setModalOpen(false);
  };

  const curatePinnedContent = async (category) => {
    const res = await axiosInstance.get(`${CMS_BASE_URL}/content-type/${category}/`, {
      headers: { Authorization: `JWT ${localStorage.access}` },
    });
    return { [category]: res?.data };
  };


  const handlePinnedContentFormatting = async () => {
    setLoading(true);
    try {
      const final = [];
      let unformatted = [];
      for (const key of Object.keys(CMS_SLUG_TO_LABEL)) {
        try {
          let temp = await curatePinnedContent(key);
          if (temp && temp[key]) {
            unformatted = unformatted.concat([...temp[key]]);
            final.push(temp);
          }
        } catch (err) {
          console.error(`Error curating content for category ${key}:`, err);
        }
      }
      setFormattedData(final);
      setData(unformatted);
    } catch (e) {
      console.error("Error in handlePinnedContentFormatting:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handlePinnedContentFormatting();
  }, []);

  const handleNewPinContent = () => {
    if (!selectedCategory || !selectedMedia || !selectedContent) {
      notify("You need to select a category, media type and item!", "error");
      return;
    }

    pinContentForPatientLogic({
      identifier: selectedContent?.value?.id,
      patient: patientID.toString(),
      type: selectedMedia?.value,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          notify("Content pinned successfully!");
          dispatch(fetchPatientPCLogic(patientID));
          closeModal();
        }
      })
      .catch((err) => {
        console.log("Error pinning content", err);
        notify("Something went wrong!", "error");
      });
  };
  useEffect(() => {
    const tempCategories = [];
    const seenItems = {};
    const tempContent = [];
    const filteredData = data.filter((item) => {
      const appType = item?.app_type?.App;
      if (process.env.REACT_APP_DASHBOARD_TYPE === "youth"){
          return appType !== "Adult";
          } else {
            return appType !== "Youth";
          }
    });
    for (const item in data) {
      const name = data[item]?.classification?.Name;
      if (name?.length > 0 && !(name in seenItems)) {
        seenItems[name] = 1;
        tempCategories.push({
          label: name,
          value: name,
        });
      }

      tempContent.push({
        label: data[item]?.Title,
        value: data[item],
      });
    }
    setCategories([...tempCategories]);
    setContent([...tempContent]);
  }, [formattedData, data]);

  useEffect(() => {
    if (selectedCategory && selectedMedia) {
      const temp = [];
      data.forEach((content) => {
        if (
          normalizeMediaType(content?.media_type) === selectedMedia?.label &&
          content?.classification?.Name === selectedCategory?.label
        ) {
          //*Doing a return was returning the item itself and not the desired structure even after modifications, hence the array push.
          temp.push({
            label: content?.Title,
            value: content,
          });
        }
      });
      const filteredData = temp.filter((item) => {
        const appType = item?.value?.app_type?.App;
        if (process.env.REACT_APP_DASHBOARD_TYPE === "youth"){
          return appType !== "Adult";
          } else {
            return appType !== "Youth";
          }
      });
      setContent(filteredData);
    }
  }, [selectedCategory, selectedMedia]);

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
        ariaHideApp={false}
      >
        <CardLayout>
          <div className="container-fluid d-flex mt-4">
            <h3 className="primary-text-blue">Pin New Content</h3>
          </div>
          <div className="container-fluid px-5 py-2">
            {loading ? (
              <PatientLoader />
            ) : (
              <>
                <div className="container-fluid row py-4 px-0">
                  <div className="col-sm-12 col-md-6 col-lg-6 container-fluid">
                    <div className="form-group mb-4">
                      <label>Select Category</label>

                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            border: "0px",
                            borderBottom: "1px solid #94A3B8",
                            borderRadius: "0px",
                            padding: "5px",
                          }),
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                        placeholder="Select"
                        classNamePrefix="select"
                        name="category"
                        value={selectedCategory}
                        onChange={(e) => {
                          setSelectedCategory(e);
                        }}
                        options={categories}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label>Select Media</label>

                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            border: "0px",
                            borderBottom: "1px solid #94A3B8",
                            borderRadius: "0px",
                            padding: "5px",
                          }),
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                        placeholder="Select"
                        classNamePrefix="select"
                        name="media"
                        value={selectedMedia}
                        onChange={(e) => {
                          setSelectedMedia(e);
                        }}
                        options={media}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label>Select title to pin</label>

                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            border: "0px",
                            borderBottom: "1px solid #94A3B8",
                            borderRadius: "0px",
                            padding: "5px",
                          }),
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                        placeholder="Select"
                        classNamePrefix="select"
                        name="content"
                        value={selectedContent}
                        onChange={(e) => {
                          setSelectedContent(e);
                        }}
                        options={content}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 container-fluid">
                    {selectedContent ? (
                      <>
                        {selectedMedia?.label === "Videos" && (
                          <div
                            className="preview-section"
                            dangerouslySetInnerHTML={{
                              __html: selectedContent?.value?.Embed,
                            }}
                          />
                        )}

                        {/* {selectedMedia?.label === "TikToks" && (
                          <div
                            className="preview-section"
                            dangerouslySetInnerHTML={{
                              __html: selectedContent?.value?.TikTokEmbed,
                            }}
                          />
                        )} */}

                        {selectedMedia?.label === "Audio" && (
                          <div className="text-center container-fluid">
                            <video
                              width="100%"
                              height="100%"
                              controls
                              name="media"
                            >
                              <source
                                src={selectedContent?.value?.Audio?.url}
                                type="audio/mpeg"
                              />
                            </video>
                          </div>
                        )}

                        {selectedMedia?.label === "Article" && (
                          <textarea
                            style={{
                              height: "100%",
                              width: "100%",
                              userSelect: "none",
                              resize: "none",
                              border: "none",
                              outline: "none",
                            }}
                            readOnly
                            value={selectedContent?.value?.Body}
                          />
                        )}
                      </>
                    ) : (
                      <div className="preview-section-blank">
                        <span>Select an item to preview</span>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  style={{ gap: "10px" }}
                  className="container-fluid d-flex justify-content-end mt-4 px-2"
                >
                  <button
                    className="btn alternative-btn"
                    style={{ width: "25%" }}
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={
                      !(selectedCategory && selectedContent && selectedMedia)
                    }
                    style={{ width: "25%" }}
                    className="primary-btn"
                    onClick={handleNewPinContent}
                  >
                    Pin Content
                  </button>
                </div>
              </>
            )}
          </div>
        </CardLayout>
      </Modal>
    </div>
  );
};

export default PinNewContent;
